/**
 * @notes: Route constants
 */

export const BASE_ROUTE = "/admin";
export const LOGIN_ROUTE = "/login";
export const SIGNUP_ROUTE = "/welcome";
export const SCANNER_ROUTE = "/scanner";
export const HOME_ROUTE = `/home`;
export const DASHBOARDS_ROUTE = `/dashboards`;
export const USERS_ROUTE = `/users`;
export const TEAMS_ROUTE = `/teams`;
export const LICENSES_ROUTE = `/licenses`;
export const CLIENTS_ROUTE = `/clients`;
/** Nested under a client: the web access profiles belong to its configuration. */
export const WEB_ACCESS_PROFILES_SEGMENT = "web-profiles";
export const MOBILE_ACCESS_PROFILES_SEGMENT = "mobile-profiles";
export const ACCESS_PROFILES_SEGMENTS = [
  WEB_ACCESS_PROFILES_SEGMENT,
  MOBILE_ACCESS_PROFILES_SEGMENT,
];
/** Stands in for the profile name while it is being created. */
export const NEW_ACCESS_PROFILE = "new";
/**
 * Set on the client route to reopen a form section in edit mode. Used when
 * coming back from a sub-page so the Ops lands where they left off.
 */
export const EDIT_SECTION_PARAM = "editSection";
export const WORKFLOWS_ROUTE = `/workflows`;
export const LISTS_ROUTE = `/lists`;
export const CUSTOMERS_ROUTE = `/customer`;
export const PLACES_ROUTE = `/map`;
export const PICTURES_ROUTE = "/pictures";
export const DOCUMENTS_ROUTE = "/documents";
export const ENVIRONMENT_ROUTE = `/environment`;
export const BACKGROUND_OPERATIONS_ROUTE = `/background_operations`;
export const ERP_ROUTE = `/erp`;
export const PANORAMA_ROUTE = `/panorama`;
export const CALENDAR_ROUTE = `/calendar`;
export const DETECT_ROUTE = `/detect`;
/** Where a user lands when the landing page of their profile is out of reach. */
export const UNREACHABLE_LANDING_PAGE_ROUTE = "/unreachable-landing-page";

export const APP_PATHS = {
  CALENDAR_ROUTE: [CALENDAR_ROUTE],
  HOME_ROUTE: ["/", HOME_ROUTE],
  DASHBOARDS_ROUTE: [
    DASHBOARDS_ROUTE,
    `${DASHBOARDS_ROUTE}/:folder`,
    `${DASHBOARDS_ROUTE}/:folder/create`,
    `${DASHBOARDS_ROUTE}/:folder/:dashboard_id/edit`,
    `${DASHBOARDS_ROUTE}/:folder/:dashboard_id`,
  ],
  USERS_ROUTE: [
    USERS_ROUTE,
    `${USERS_ROUTE}/:subCategory`,
    `${USERS_ROUTE}/:subCategory/:user_id`,
  ],
  CLIENTS_ROUTE: [
    CLIENTS_ROUTE,
    `${CLIENTS_ROUTE}/:client_id`,
    `${CLIENTS_ROUTE}/:client_id/${WEB_ACCESS_PROFILES_SEGMENT}/:profile_name`,
    `${CLIENTS_ROUTE}/:client_id/${MOBILE_ACCESS_PROFILES_SEGMENT}/:profile_name`,
  ],
  ENVIRONMENT_ROUTE: [ENVIRONMENT_ROUTE, `${ENVIRONMENT_ROUTE}/:subCategory`],
  BACKGROUND_OPERATIONS_ROUTE: [BACKGROUND_OPERATIONS_ROUTE],
  TEAMS_ROUTE: [
    TEAMS_ROUTE,
    `${TEAMS_ROUTE}/:id`,
    `${TEAMS_ROUTE}/:id/edit`,
    `${TEAMS_ROUTE}/create`,
  ],
  WORKFLOWS_ROUTE: [
    WORKFLOWS_ROUTE,
    `${WORKFLOWS_ROUTE}/:workflow_id/edit`,
    `${WORKFLOWS_ROUTE}/:workflow_id`,
    `${WORKFLOWS_ROUTE}/create`,
    `${WORKFLOWS_ROUTE}/activities/:activity_id`,
    `${WORKFLOWS_ROUTE}/activities/:activity_id/edit`,
    `${WORKFLOWS_ROUTE}/activities/:activity_id/view`,
    `${WORKFLOWS_ROUTE}/activities/:activity_id/reports/:report_id`,
    `${WORKFLOWS_ROUTE}/activities/create`,
    `${WORKFLOWS_ROUTE}/jobs/:job_type/:job_id/edit`,
    `${WORKFLOWS_ROUTE}/jobs/:job_type/:job_id`,
    `${WORKFLOWS_ROUTE}/jobs/:job_type/create`,
    `${WORKFLOWS_ROUTE}/jobs/:job_type`,
    `${WORKFLOWS_ROUTE}/triggers`,
    `${WORKFLOWS_ROUTE}/triggers/create`,
    `${WORKFLOWS_ROUTE}/triggers/:trigger_id`,
    `${WORKFLOWS_ROUTE}/triggers/:trigger_id/edit`,
    `${WORKFLOWS_ROUTE}/webhooks`,
    `${WORKFLOWS_ROUTE}/webhooks/create`,
    `${WORKFLOWS_ROUTE}/webhooks/:webhook_id`,
    `${WORKFLOWS_ROUTE}/webhooks/:webhook_id/edit`,
  ],
  LISTS_ROUTE: [
    LISTS_ROUTE,
    `${LISTS_ROUTE}/:list_id`,
    `${LISTS_ROUTE}/:list_id/edit`,
    `${LISTS_ROUTE}/:list_id/edit`,

    `${LISTS_ROUTE}/:list_id/view`,
    `${LISTS_ROUTE}/create`,
  ],

  CUSTOMER_ROUTE: [
    CUSTOMERS_ROUTE,
    `${CUSTOMERS_ROUTE}/edit`,
    `${CUSTOMERS_ROUTE}/view`,
  ],

  PANORAMA_ROUTE: [
    PANORAMA_ROUTE,
    `${PANORAMA_ROUTE}/balances`,
    `${PANORAMA_ROUTE}/customers`,
    `${PANORAMA_ROUTE}/customers_new`,
    `${PANORAMA_ROUTE}/customer_groups`,
    `${PANORAMA_ROUTE}/discounts`,
    `${PANORAMA_ROUTE}/distributors`,
    `${PANORAMA_ROUTE}/lines`,
    `${PANORAMA_ROUTE}/orders`,
    `${PANORAMA_ROUTE}/products`,
    `${PANORAMA_ROUTE}/product_groups`,
    `${PANORAMA_ROUTE}/prices_new`,
    `${PANORAMA_ROUTE}/prices`,
    `${PANORAMA_ROUTE}/recommendations`,
    `${PANORAMA_ROUTE}/stock_new`,
    `${PANORAMA_ROUTE}/stock`,
    `${PANORAMA_ROUTE}/warehouses`,
  ],
  ERP_ROUTE: [
    ERP_ROUTE,
    `${ERP_ROUTE}/orders`,
    `${ERP_ROUTE}/old_stock`,
    `${ERP_ROUTE}/prices`,
    `${ERP_ROUTE}/orders/:orderId`,
    `${ERP_ROUTE}/orders/:orderId/return`,
    `${ERP_ROUTE}/discounts`,
    `${ERP_ROUTE}/lists`,
    `${ERP_ROUTE}/stock_movements`,
    `${ERP_ROUTE}/stock_movements/:stockMovementId`,
    `${ERP_ROUTE}/:list_id`,
    `${ERP_ROUTE}/:list_id/edit`,
    `${ERP_ROUTE}/:list_id/view`,
  ],
  DETECT_ROUTE: [
    DETECT_ROUTE,
    `${DETECT_ROUTE}/catalogue`,
    `${DETECT_ROUTE}/detect_pictures`,
  ],
  PLACES_ROUTE: [PLACES_ROUTE, `${PLACES_ROUTE}/:id`],
  PICTURES_ROUTE: [PICTURES_ROUTE],
};
